export function escapeCSV(term: string) {
  if (term.match(/[,"']/)) {
    return `"${term
      .replace(/"/g, '""')
      .replace(/,/g, ",")
      .replace(/'/g, "'")}"`;
  }

  return term;
}
